import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IFullStressLastNotificationTimeResponse,
} from "models/stressCheck/fullStressLastNotificationTime";
import { httpStatus } from "configs/httpStatus";
import { getFullStressLastNotificationTime } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./fullStressLastNotificationTimeActions";

function* fullStressLastNotificationTimeSaga() {
  try {
    const response: IFullStressLastNotificationTimeResponse = yield call(
      getFullStressLastNotificationTime
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetFullStressLastNotificationTimeWatcher() {
  yield takeLatest(
    ActionType.FULL_STRESS_LAST_NOTIFICATION_TIME as any,
    fullStressLastNotificationTimeSaga
  );
}

export default [fork(onGetFullStressLastNotificationTimeWatcher)];
